import { template as template_c444cf1bd1694fe0ab5bb6172d5b61b2 } from "@ember/template-compiler";
import { hash } from '@ember/helper';
const JemViewFileDetails = template_c444cf1bd1694fe0ab5bb6172d5b61b2(`
{{#if @childStatus.uploadedData}}
  <div class="file-name text-gray-800">{{@childStatus.uploadedData.fileName}}</div>
{{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default template_c444cf1bd1694fe0ab5bb6172d5b61b2(`
  {{yield
    (hash
      taskDetails=(component
        JemViewFileDetails
        disabled=@disabled
        notAuthorized=@notAuthorized
        isAuto=@task.isAuto
        childStatus=@childStatus
        taskConfig=@taskConfig
      )
    )
  }}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
